export const generateHTML = (captchaConfig, pageLanguage) => { return `
<script nomodule src="${captchaConfig.captchaCDN}" async defer></script>
<script>
	function destyleMktoForm(mktoForm, moreStyles){
		Array.from(document.styleSheets).forEach(function(ss) {
		
			if ( [mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1) {
				ss.disabled = true;
			}
		})
	}

	function hideFrcBanner() {
		const query = '.frc-banner { display: none !important }'
		var styleNode = document.createElement('style');
		styleNode.type = "text/css";
		if(!!(window.attachEvent && !window.opera)) {
			styleNode.styleSheet.cssText = query;
	   	} else {
			var styleText = document.createTextNode(query);
			styleNode.appendChild(styleText);
	   	}
	   	document.getElementsByTagName('head')[0].appendChild(styleNode);
	}
	
	if(MktoForms2){
		MktoForms2.whenRendered(function(form) {
			form.onValidate(async (nativeValid) => {
				if (!nativeValid) return;
				let prevSubmittable = form.submittable();
				if(form.getFormElem().length) {
					if(window.friendlyCaptchaValidation === 1) {
						form.submittable(prevSubmittable)
						return;
					}
					form.submittable(false);
					const input = form.getFormElem()[0].querySelector("input[name='frc-captcha-solution'][class='frc-captcha-solution']")
					if(input && input.value) {
						var xhttp = new XMLHttpRequest();
						xhttp.open("POST", "/bin/captcha-verification", false);
						xhttp.setRequestHeader("Content-Type", "application/json");
						xhttp.send(JSON.stringify({solution: input.value}));
						if (xhttp.status === 200){
							document.getElementById("nicetry").value = "";
							window.friendlyCaptchaValidation = 1;
							form.submittable(prevSubmittable)
						} else {
							document.getElementById("nicetry").value = "Error Captcha";
							form.submittable(false)
						}
					} else {
						form.submittable(prevSubmittable);
					}
				} else {
					form.submittable(prevSubmittable);
				}
			});
			destyleMktoForm(form);
			hideFrcBanner();
			Array.from(document.getElementsByClassName('mktoField')).forEach((element)=>{
				element.setAttribute("placeholder", ".");
			})
			Array.from(form.getFormElem()[0].getElementsByClassName('mktoButtonRow')).forEach((buttonRow)=>{
				if(!form.getFormElem()[0].querySelector('div[data-captcha-instance]')) {
					const element = document.createElement("div");
					element.setAttribute('data-captcha-instance', 'true')
					buttonRow.parentElement.append(element);
					const button = buttonRow.getElementsByTagName("button")[0];
					button.setAttribute("disabled", "disabled");
					button.classList.add("disabled");
					const myCustomWidget = new friendlyChallenge.WidgetInstance(element, {
						secret: "${captchaConfig.secret}",
						sitekey: "${captchaConfig.sitekey}",
						puzzleEndpoint: "${captchaConfig.puzzleEndpoint}",
						startMode: "${captchaConfig.startMode}",
						language: ${pageLanguage !== "fr"? "\""+pageLanguage+"\"": `{
							text_init: "Chargement...",
							text_ready: "Vérification Anti-Robot",
							button_start: "Cliquez ici pour vérifier",
							text_fetching: "Chargement du défi",
							text_solving: "Nous vérifions que vous n'êtes pas un robot...",
							text_completed: "Je ne suis pas un robot",
							text_completed_sr: "Vérification automatique des spams terminée",
							text_expired: "Vérification anti-robot expirée",
							button_restart: "Redémarrer",
							text_error: "Échec de la vérification",
							button_retry: "Recommencer",
							text_fetch_error: "Problème de connexion avec"}`},
						doneCallback: solution => {
							button.removeAttribute("disabled")
							button.classList.remove("disabled");
						}
					})
				}
			})
		});
	}
</script>
`}